var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIron = function SvgIron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.518 3.312a.75.75 0 0 1 .184 1.044l-8.213 11.73.026.027c.01.008.018.017.027.026l11.73-8.213a.75.75 0 0 1 1.044.184l.574.819a2.75 2.75 0 0 1-.675 3.83l-13.03 9.123a3.75 3.75 0 0 1-4.97-.469 3.75 3.75 0 0 1-.47-4.97l9.124-13.03a2.75 2.75 0 0 1 3.83-.675l.82.574ZM13.487 19.14l10.867-7.61a1.25 1.25 0 0 0 .307-1.74l-.143-.205-11.21 7.848c.19.546.252 1.13.179 1.707Zm-2.034-1.965a2.25 2.25 0 0 1-3.176 3.176 2.25 2.25 0 0 1 3.176-3.176Zm-.258-1.856a3.768 3.768 0 0 0-1.707-.178l7.61-10.867a1.25 1.25 0 0 1 1.74-.307l.205.143-7.848 11.21Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.565 20.001a.75.75 0 1 0-1.06-1.06l-.964.964c-.674.673-.911 1.683-.584 2.533l-.22.22-2.121 2.121a.75.75 0 0 0 1.06 1.061l2.122-2.121.156-.157c.893.476 2.031.262 2.769-.475l.964-.965a.75.75 0 0 0-1.06-1.06l-.965.964c-.39.39-.907.347-1.157.096-.25-.25-.294-.766.096-1.157l.964-.964Z",
    fill: "#191919"
  })));
};

export default SvgIron;